<app-tooltip
    class="objective-icon w-100"
    appCustomPopover
    popoverText="{{tooltip}}"
    placement="top"
    [popoverTextParam]="textParam"
    [adaptPlacement]="true"
    [ngClass]="{ 'white-background': whiteBackground }"
    [@fadeInOnEnter]
>
    <ng-container icon>
        <div class="objective-content"
             [ngClass]="{'loading': !hasLoaded}">
            <div class="h-100 route-planning-allocated-tasks">
                @if (hasLoaded) {
                    <div class="objective-label route-planning-allocated-tasks-name">
                        <span>{{ translation | translate }}</span>
                    </div>
                    <div
                        class="objective-value"
                        [@fadeInOnEnter]
                        [ngClass]="{'increase':increase,'decrease':increase === false}"
                    >
                        <ng-content select="[content]">
                        </ng-content>
                    </div>
                }
            </div>
        </div>
    </ng-container>
</app-tooltip>
